import { Box } from '@cp/ds/src/components/box';
import { SxProps } from '@mui/material';
import React from 'react';

export const SideLine: React.FC<{ sx?: SxProps }> = (props) => {
  const { sx } = props;
  return <Box sx={{ left: 0, position: 'absolute', width: 4, ...sx }} />;
};
